export default __webpack_public_path__ + "static/media/padlock.7c9ee150.svg";